import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngbd-logout-modal',
  template: `
    <div class="modal-header">
      <p class="modal-title"><fa-icon [icon]="['fas', 'sign-out-alt']" class="mr-2" [fixedWidth]="true"></fa-icon>{{ 'label.bekrafta-utloggning' | translate }}</p>
    </div>
    <div class="modal-body">
      <p class="text-justify ml-3 mr-3" style="font-size: 1.1em;">{{ 'label.ar-du-saker-pa-att-du-vill-logga-ut' | translate }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary btn-modal" (click)="close()">{{ 'button.nej' | translate }}</button>
      <button type="button" class="btn btn-danger btn-modal" data-dismiss="modal" (click)="logout()">{{ 'button.ja' | translate }}</button>
    </div>`,
  styles: [`
    .modal-header {
      border-bottom: none;
      background-color: #2dbdb6;
      color: #fff
    }
    .modal-body, .modal-footer {
      background-color: #f3f3f3
    }
    .modal-footer {
      border-top: none
    }
  `]
})
export class NgbdLogoutModal {

  constructor(
    protected activeModal: NgbActiveModal,
    protected router: Router,
    protected auth: AuthService) {
  }

  public logout() {
    this.close();
    this.auth.logout(true);
  }

  public close() {
    this.activeModal.close();
  }
}
